import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {assignProductSeatBulk, getProductSeatBulkProgress, stopProductSeatBulk} from 'src/openapi/admin/apis/BulkProductSeatAssignmentApi';
import {useAppDispatch} from 'src/store/hooks';

import {AssignProductSeatModal} from './assign-product-seat.modal';
import {selectAssignProductSeatTask, selectAssignProductSeatUuid, setBackgroundTask, setShown, setUuid} from './assign-product-seat.slice';
import {MODAL_WIDTH, TOOL_PROGRESS_LABEL, TOOL_STACK_OVERFLOW_MESSAGE, TOOL_TASK, TOOL_TITLE} from './constants';

import type {AssignProductSeatRequest} from 'src/openapi/admin/models/AssignProductSeatRequest';

type Props = {shown: boolean, accountId: number, userIds: number[], onDone: () => void, onClose: () => void};
export const AssignProductSeatTool = ({shown, accountId, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();
    return (
        <BulkActionTool<AssignProductSeatRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}
            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}
            taskSelector={selectAssignProductSeatTask}
            uuidSelector={selectAssignProductSeatUuid}
            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(request, options) => (
                apiDispatch(assignProductSeatBulk({...options, assignProductSeatRequest: request}))
            )}
            getProgress={id => apiDispatch(getProductSeatBulkProgress({id}))}
            stopAction={id => apiDispatch(stopProductSeatBulk({id}))}
            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) =>
                <AssignProductSeatModal {...{accountId, userIds, onCloseModal, processAction}}/>}
        </BulkActionTool>
    );
};
